import { setMailboxMessageConfiguration } from 'owa-options-core';
import MarkAsReadOptionState from '../store/schema/MarkAsReadOptionState';
import store from '../store/store';
import PreviewMarkAsReadBehavior from 'owa-service/lib/contract/PreviewMarkAsReadBehavior';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import MailboxMessageConfigurationOptions from 'owa-service/lib/contract/MailboxMessageConfigurationOptions';

export interface SaveMarkAsReadOptionState {
    optionState: MarkAsReadOptionState;
    userOptions: UserOptionsType;
}

export default select<SaveMarkAsReadOptionState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('saveMarkAsReadOption')(async function saveMarkAsReadOption(
        state?: SaveMarkAsReadOptionState
    ) {
        let { optionState, userOptions } = state;
        let serviceObject: MailboxMessageConfigurationOptions = {};

        if (optionState.behavior !== null) {
            userOptions.PreviewMarkAsRead = optionState.behavior;

            // This conversion is required because UserOptions deal with string literals (MarkAsRead type),
            // whereas MailboxMessageConfigurationOptions deals with numbers (PreviewMarkAsReadBehavior const enum type)
            switch (state.optionState.behavior) {
                case 'Delayed':
                    serviceObject.PreviewMarkAsReadBehavior = PreviewMarkAsReadBehavior.Delayed;
                    break;
                case 'OnSelectionChange':
                    serviceObject.PreviewMarkAsReadBehavior =
                        PreviewMarkAsReadBehavior.OnSelectionChange;
                    break;
                case 'Never':
                    serviceObject.PreviewMarkAsReadBehavior = PreviewMarkAsReadBehavior.Never;
                    break;
            }
        }

        if (optionState.delay !== null) {
            userOptions.MarkAsReadDelaytime = optionState.delay;
            serviceObject.PreviewMarkAsReadDelaytime = optionState.delay;
        }

        await setMailboxMessageConfiguration(serviceObject);
    })
);
